import { render, staticRenderFns } from "./SyaratBayar.vue?vue&type=template&id=07e9a70c&"
import script from "./SyaratBayar.vue?vue&type=script&lang=js&"
export * from "./SyaratBayar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports